// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4891f270","453":"72e423bd","455":"b45092f4","977":"e219c83c"}[chunkId] + ".chunk.js";
};